import { Suspense } from "react";
import Providers from "./layouts/provider.layout";
import "react-contexify/dist/ReactContexify.css";
import { Loader } from "./components";
import ErrorBoundary from "./ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import * as Sentry from "@sentry/react";
import './assets/rsuite-theme.less';
import config from "./config";

function App() {
  if (!Sentry.isInitialized()) {
    Sentry.init({
      dsn: config.sentry.dsn,
      release: `winz-portal@${config.version}`, // Use release for Sentry source map matching
      dist: config.version,           // Use dist for Sentry source map matching
      environment: config.env,
      _experiments: { enableLogs: true },
      integrations: [
        Sentry.replayIntegration({
          maxReplayDuration: 30000, // 30 seconds in milliseconds
          maskAllText: false,
          blockAllMedia: false,
        })
      ],
      sendDefaultPii: true,
      // Don't sample any sessions that don't have errors
      replaysSessionSampleRate: 0,
      //TODO: Update this to a higher value in production
      // Only keep 0% of sessions with errors
      replaysOnErrorSampleRate: 0,
    });
  }
  

  return (
    <ThemeProvider>
      <div id="app" className="app noselect">
        <Suspense fallback={<Loader />}>
          <ErrorBoundary>
            <Providers />
          </ErrorBoundary>
        </Suspense>
      </div>
    </ThemeProvider>
  );
}

export default App;
